<template>
    <div>
        <a-table
            :key="this.loading.key"
            :columns="columns"
            :rowKey="record => record.id"
            :dataSource="list"
            :pagination="false"
            :loading="this.loading.effects['domainname/select'] || this.loading.effects['domainname/delete']"
        >
            <template slot="operation" slot-scope="text,record">
                <router-link
                    class="mr10"
                    :to="{
                    path:'detail',
                    query: {
                        id: record.id,
                        //这里注意this的作用域指向问题
                        referer: JSON.stringify(that.$route.query),
                    }
                }"
                >详情</router-link>
                <router-link
                    class="mr10"
                    :to="{
                    path:'edit',
                    query: {
                        id: record.id,
                        //这里注意this的作用域指向问题
                        referer: JSON.stringify(that.$route.query),
                    }
                }"
                >编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                    <a :disabled="that.loading.effects['domainname/delete']" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <v-pageinfo v-if="pagination.total > 0" :pagination="pagination"></v-pageinfo>
    </div>
</template>

<script>
import { mapState } from "vuex";
let pagination={
    total:0,
    pageSize:0,
    current:1,
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "域名说明",
        dataIndex: "domaindesc"
    },
    {
        title: "域名地址",
        dataIndex: "domainurl"
    },
    {
        title: "鉴权数据获取接口",
        dataIndex: "authserviceconfig"
    },
    {
        title: "鉴权参数获取方式",
        dataIndex: "authtype"
    },
    {
        title: "鉴权参数标识",
        dataIndex: "authtag"
    },
    {
        title: "应用环境",
        dataIndex: "env"
    },
    {
        title: "返回结构",
        dataIndex: "loginserviceconfig"
    },
    {
        title: "备注",
        dataIndex: "remark"
    },
    {
        title: "操作",
        width: 146,
        scopedSlots: { customRender: "operation" }
    }
];

export default {
    data() {
        return {
            columns,
            that: this
        };
    },
    methods: {
        //删除域名
        onDelete(record) {
            this.$store.dispatch({
                type: "domainname/deleteDomainname",
                params: record
            }).then(() => {
                this.$store.dispatch({
                    type: "domainname/selectTableList",
                    params:{}
                });
            });
        }
    },
    computed: {
        ...mapState("domainname", {
            list: state => state.list,
            pagination: state => {
                pagination = state.pagination
                return state.pagination;
            }
        })
    },
    mounted() {
        this.$store.dispatch({
            type: "domainname/selectTableList",
            params:{}
        });
    }
};
</script>
<style lang="less" scoped>
</style>
